function CardTrend({ img, title, product }) {
  return (
    <div className="flex items-center p-1 border rounded-lg shadow-md cursor-pointer space-x-4">
      <img
        src={img}
        alt=""
        className="object-contain"
        width="100"
        height="100"
      />
      <div>
        <h1 className="text-gray-800 font-bold text-lg">{title}</h1>
        <p className="text-gray-500">{product} produk</p>
      </div>
    </div>
  );
}

export default CardTrend;
